import Vue from 'vue'
import Vuetify, {VTextField} from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
	iconfont: 'fa',
	theme: {
		primary: '#51A45C',
		secondary: '#366f3d',
		accent: '#81c189',
		error: '#e60000',
		info: '#0b7ed9',
		success: '#5AB963',
		// 	warning: '#FFC107'
	},
	components: {
		VTextField
	}
})